/**
 * Quick Post Type Definitions
 * Twitter 스타일의 빠른 글 작성 기능을 위한 타입 정의
 */

/**
 * Quick Post 입력 데이터
 */
export interface QuickPostInput {
  /** 본문 내용 (필수) */
  body: string
  /** 첨부 이미지 파일 (선택) */
  image?: File
}

/**
 * 가공된 Quick Post 데이터 (게시 준비 완료)
 */
export interface QuickPostData {
  /** 자동 생성된 제목 (256바이트 이하) */
  title: string
  /** 본문 내용 (이미지 마크다운 포함 가능) */
  body: string
  /** 태그 배열 (fast-steemit 필수 + 추출된 해시태그) */
  tags: string[]
  /** 타임스탬프 기반 permlink */
  permlink: string
  /** 업로드된 이미지 URL (선택) */
  imageUrl?: string
}

/**
 * Quick Post 폼 UI 상태
 */
export interface QuickPostFormState {
  /** 입력 중인 본문 */
  body: string
  /** 선택된 이미지 파일 */
  imageFile: File | null
  /** 이미지 미리보기 URL (로컬 blob URL) */
  imagePreviewUrl: string | null
}

/**
 * Quick Post 상태
 */
export type QuickPostStatus = 'idle' | 'uploading' | 'posting' | 'error' | 'success'

/**
 * Quick Post 결과
 */
export interface QuickPostResult {
  success: boolean
  /** 성공 시 생성된 permlink */
  permlink?: string
  /** 실패 시 에러 메시지 */
  error?: string
  /** 이미지 업로드 실패 여부 (재시도/건너뛰기 선택용) */
  imageUploadFailed?: boolean
}

/**
 * Quick Post 훅 반환 타입
 */
export interface UseQuickPostReturn {
  /** 현재 상태 */
  status: QuickPostStatus
  /** 에러 메시지 */
  error: string | null
  /** 업로드 진행률 (0-100) */
  uploadProgress: number
  /** Quick Post 제출 함수 */
  submit: (input: QuickPostInput) => Promise<QuickPostResult>
  /** 상태 초기화 함수 */
  reset: () => void
}

/**
 * Quick Post 상수
 */
export const QUICK_POST_CONSTANTS = {
  /** 제목 최대 바이트 */
  TITLE_MAX_BYTES: 256,
  /** 태그 최대 개수 */
  MAX_TAGS: 5,
  /** 기본 태그 */
  DEFAULT_TAG: 'fast-steemit',
  /** 이미지 최대 크기 (바이트) */
  IMAGE_MAX_SIZE: 10 * 1024 * 1024,
  /** 지원 이미지 형식 */
  SUPPORTED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
} as const
